/**
 * Godot's 1D `Curve` resource: the scalar `f(offset) -> value` curve of particle
 * parameters and `CurveTexture`, sampled as a cubic Bézier between points. The
 * `curve2d` and `curve3d` slices decode path geometry. No THREE, so the linter reads it.
 */
/** `Curve::_bake_resolution` (`curve.h:163`). */
export const DEFAULT_BAKE_RESOLUTION = 100;
/** A `Curve` with no points, for which Godot's `sample()` answers 0. */
export const EMPTY_CURVE = {
    points: [],
    minValue: 0,
    maxValue: 1,
    minDomain: 0,
    maxDomain: 1,
    bakeResolution: DEFAULT_BAKE_RESOLUTION,
};
//# sourceMappingURL=types.js.map